// src/lib/site.config.ts
// Centralized site identity — edit this one file when starting a new project.

export const siteConfig = {
  name: "Kraken Technology",
  tagline: "Disruptive Maritime Capabilities",
  url: process.env.NEXT_PUBLIC_SITE_URL || "https://krakentechnology.com",

  // Default SEO
  defaultTitle: "Kraken Technology",
  defaultDescription:
    "British designer of autonomous maritime platforms delivering disruptive littoral, surface and subsurface capabilities for defence, security and commercial.",
  titleTemplate: "%s | Kraken Technology", // used by generateTitle in payload.config.ts

  // Default author/team
  defaultAuthor: "Kraken Technology",

  // Cookie consent
  cookieStorageKey: "cookie-consent",

  // Articles
  blogPath: "/articles",
  blogTitle: "News",
  blogDescription: "The most recent developments from across Kraken Technology.",

  // Email defaults (fallbacks if env vars not set)
  email: {
    fromAddress: "contact@krakentechnology.com",
    fromName: "Kraken Technology",
  },
} as const;
